var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor-js',{attrs:{"data":_vm.data.columns[0].content},on:{"save":function (d) { return _vm.save(0, d); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }